module.exports = __webpack_public_path__ + "static/img/health_monitor.60e09523.png";